export default import.meta.ROLLUP_FILE_URL_LzJHFFIVBWn8Q3MUH6vazg